export default __webpack_public_path__ + "static/media/fevr-distribution-table.410d6df6.svg";